import { MapUtils } from '../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, isSameData, isSameList, SerializationContext, SerializedData } from '../../dto/dto.js';
import { fromEnumAsString, toEnumFromString } from '../../../serialization/enum-utils.js';
import { Invoice } from './invoice.js';

export enum InvoiceActionType {
  Create = 'CREATE',
  Cancel = 'CANCEL',
  Modify = 'MODIFY',
}

export class InvoiceAction extends DataModel {
  static readonly TYPE_ID: string = 'a975a3baf62d4b8889483520d3119a03';

  private constructor(
    public readonly type: InvoiceActionType,
    private readonly invoices: Invoice[],
  ) {
    super();
  }

  get isEmpty(): boolean {
    return this.invoices.length <= 0;
  }

  get numberOfInvoices(): number {
    return this.invoices.length;
  }

  get $typeId() {
    return InvoiceAction.TYPE_ID;
  }

  static asCreate(invoice: Invoice): InvoiceAction {
    return new InvoiceAction(
        InvoiceActionType.Create,
        [invoice],
    );
  }

  static asCancel(invoice: Invoice): InvoiceAction {
    return new InvoiceAction(
        InvoiceActionType.Cancel,
        [invoice],
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): InvoiceAction {
    return new InvoiceAction(
        toEnumFromString(MapUtils.get<string>(map, 'type'), InvoiceActionType),
        MapUtils.getList<Invoice>(map, 'invoices', (value) => {
          return context.fromData<Invoice>(value as SerializedData);
        }),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'type': fromEnumAsString(this.type),
      'invoices': this.invoices.map((e) => context.toData(e)),
    };
  }

  clone(): this {
    return new InvoiceAction(
        this.type,
        this.invoices.map((e) => e.clone()),
    ) as this;
  }

  isSame(other: InvoiceAction): boolean {
    if(this === other) {
      return true;
    }

    return this.type === other.type &&
      isSameList(other.invoices, this.invoices, isSameData);
  }

  getInvoice(index: number): Invoice {
    return this.invoices[index];
  }

  getAllInvoices(): Invoice[] {
    return [...this.invoices];
  }
}

export class InvoiceActionBuilder extends DataModelBuilder<InvoiceAction> {
  build(context: SerializationContext, map: SerializedData): InvoiceAction {
    return InvoiceAction.fromMap(context, map);
  }
}
